import React from 'react';

import ReviewersComponent from 'components/Reviewers';

const Reviewers: React.FC = () => <ReviewersComponent />;

export default Reviewers;
